<!-- <app-circle-p></app-circle-p> -->
<div style="text-align:start" >
  <div class="container" [style.background-image]="popularMovieImageUrl" (click) = "onMovieDes()">
    <!-- <div class="overlay">
      <div class="items"></div>
      <div class="items head">
        <p>Flower Embroidery Hoop Art</p>
        <hr>
      </div>
      <div class="items price">
        <p class="old">$699</p>
        <p class="new">$345</p>
      </div>
      <div class="items cart">
        <i class="fa fa-shopping-cart"></i>
        <span>ADD TO CART</span>
      </div>
    </div> -->
    <h6 class="fw-normal list-movie-title">{{originalTitle}}</h6>
  </div>
  <!-- <p style="margin:0px;padding:0px">{{releaseDate}}</p> -->
</div>

